import React, { useEffect } from "react";
import bgImage from "./DeeplinkImages/backgroundImage.png";
import mobileBg from "./DeeplinkImages/mobileview.png";
import phoneImg from "./DeeplinkImages/Samsung.svg";
import logo from "./DeeplinkImages/vylor_mcrc.svg";
import appStore from "./DeeplinkImages/imageAppStore.png";
import playStore from "./DeeplinkImages/imageGooglePlay.png";

const PLAY_STORE_BASE =
    "https://play.google.com/store/apps/details?id=com.vylor.mcrc&hl=en_IN&pli=1";

const APP_STORE_BASE =
    "https://apps.apple.com/us/app/vylor-mcrc/id6793629125";

// Change this only if your app uses a different scheme
const APP_SCHEME = "vylorseedresearch://";

const getPlayStoreUrl = () => PLAY_STORE_BASE;

const getAppStoreUrl = () => APP_STORE_BASE;

const getAppDeepLink = () => APP_SCHEME;

const DeepLinkPage = () => {
    useEffect(() => {
        const ua = navigator.userAgent.toLowerCase();

        // Android
        if (ua.includes("android")) {
            const fallback = setTimeout(() => {
                // App didn't open -> Play Store
                window.location.replace(getPlayStoreUrl());
            }, 1800);

            const cancelFallback = () => {
                clearTimeout(fallback);
            };

            window.addEventListener("blur", cancelFallback, { once: true });
            window.addEventListener("pagehide", cancelFallback, { once: true });

            // Try to open app
            window.location.assign(getAppDeepLink());

            return () => {
                clearTimeout(fallback);
                window.removeEventListener("blur", cancelFallback);
                window.removeEventListener("pagehide", cancelFallback);
            };
        }

        // iPhone / iPad
        if (/iphone|ipad|ipod/.test(ua)) {
            // Redirect to App Store
            window.location.replace(getAppStoreUrl());
        }
    }, []);

    return (
        <div className="w-100 min-vh-100">

            {/* ================= MOBILE UI ================= */}
            <div className="d-block d-md-none position-relative min-vh-100 overflow-hidden">
                <img
                    src={mobileBg}
                    alt="Mobile Background"
                    className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
                />

                <div className="position-relative z-1 d-flex flex-column align-items-center min-vh-100 px-3 py-4 text-center">

                    <img
                        src={logo}
                        alt="Logo"
                        className="img-fluid mb-3"
                        style={{ width: "145px" }}
                    />

                    <h2 className="fw-bold fs-5 mb-1">
                        Available for
                    </h2>

                    <h1 className="fw-bold fs-2 mb-4">
                        DOWNLOAD!
                    </h1>

                    <img
                        src={phoneImg}
                        alt="Phone"
                        className="img-fluid mb-4"
                        style={{ width: "230px", maxWidth: "80%" }}
                    />

                    <div className="d-flex flex-column align-items-center gap-2">
                        <a
                            href={getAppStoreUrl()}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={appStore}
                                alt="App Store"
                                className="img-fluid"
                                style={{ width: "175px" }}
                            />
                        </a>
                        <a
                            href={getPlayStoreUrl()}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={playStore}
                                alt="Play Store"
                                className="img-fluid"
                                style={{ width: "175px" }}
                            />
                        </a>
                    </div>
                </div>
            </div>


            {/* ================= DESKTOP UI ================= */}
            <div className="d-none d-md-block position-relative w-100 min-vh-100">

                <img
                    src={bgImage}
                    alt="Background"
                    className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
                />

                <div className="position-relative z-1 d-flex align-items-center justify-content-between min-vh-100 px-5 px-lg-5">

                    <div>

                        <img
                            src={logo}
                            alt="Logo"
                            className="img-fluid mb-4"
                            style={{ width: "175px" }}
                        />

                        <h2 className="fw-bold fs-2 mb-2">
                            Available for
                        </h2>

                        <h1 className="fw-bold display-5 mb-4">
                            DOWNLOAD!
                        </h1>

                        <div className="d-flex gap-3">

                            <a
                                href={getAppStoreUrl()}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={appStore}
                                    alt="App Store"
                                    className="img-fluid"
                                    style={{ width: "175px" }}
                                />
                            </a>

                            <a
                                href={getPlayStoreUrl()}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={playStore}
                                    alt="Play Store"
                                    className="img-fluid"
                                    style={{ width: "175px" }}
                                />
                            </a>

                        </div>

                    </div>

                    <img
                        src={phoneImg}
                        alt="Phone"
                        className="img-fluid"
                        style={{ width: "520px", maxWidth: "45%" }}
                    />

                </div>
            </div>

        </div>
    );
};

export default DeepLinkPage;